import React, { createContext, useContext, useState } from 'react';

const ContentIsActiveContext = createContext();

// hook to use the context
export const useContentIsActive = () => {
  return useContext(ContentIsActiveContext);
};

/**
 * This component provides the `contentIsActive` state and a function to toggle its value 
 * to its children through the `ContentIsActiveContext`. 
 * It allows the child components to determine whether their content should be active or inactive.
 * 
 * The state is managed within this component and can be accessed and modified by any component 
 * that consumes the context.
 * 
 * It is intended to be used by FeatureCards and their child components.
 * 
 * @param {React.ReactNode} children - The child components that will have access to the `contentIsActive` state and `setContentIsActive` function.
 * @returns {JSX.Element} The `ContentIsActiveContext.Provider` component that wraps the children and provides the context values.
 */
export const ContentIsActiveProvider = ({ children }) => {
  const [contentIsActive, setContentIsActive] = useState(false);

  return (
    <ContentIsActiveContext.Provider value={{ contentIsActive, setContentIsActive }}>
      {children}
    </ContentIsActiveContext.Provider>
  );
};